import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer170 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_70: Record<
  Exclude<PageIdWoofzOffer170, PageIdWoofzOffer170.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer170.SUBSCRIPTIONS_OFFER1_70]: {
    id: PageIdWoofzOffer170.SUBSCRIPTIONS_OFFER1_70,
    hasHeader: false,
  },
  [PageIdWoofzOffer170.CHAT_UPSELL_OFFER1_70]: {
    id: PageIdWoofzOffer170.CHAT_UPSELL_OFFER1_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer170.UPSELL_OFFER1_70]: {
    id: PageIdWoofzOffer170.UPSELL_OFFER1_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer170.DOWNLOAD_OFFER1_70]: {
    id: PageIdWoofzOffer170.DOWNLOAD_OFFER1_70,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
